import { render, staticRenderFns } from "./OperationColumnDropdown.vue?vue&type=template&id=c60bfb88&scoped=true&"
import script from "./OperationColumnDropdown.vue?vue&type=script&lang=js&"
export * from "./OperationColumnDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60bfb88",
  null
  
)

export default component.exports